export default
{
    api           : process.env.REACT_APP_API ,
    auth_url      : '/oauth/authorize',
    client_id     : process.env.REACT_APP_CLIENT_ID,
    client_secret : process.env.REACT_APP_CLIENT_SECRET,
    homepage      : process.env.REACT_APP_HOMEPAGE ,
    logout_url    : process.env.REACT_APP_LOGOUT ,
    providers     :
    [
        'google.com' ,
        'facebook.com' ,
        'gravatar.com'
    ],
    redirect_uri  : process.env.REACT_APP_REDIRECT ,
    scope         : 'all',
    token_url     : '/oauth/token' ,
    user_url      : process.env.REACT_APP_ACCOUNT
};


// WEBPACK FOOTER //
// ./src/app/configs/auth.js